import classNames from 'classnames'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { logUtil } from 'packages/src'
import React from 'react'
import { usePreviousHookUtil } from 'modules/component/utils/hooks/usePrevious.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import 'components/Video/index.css'

let videojs

/**
 * @param props
 * @param props.source
 * @param props.poster
 * @param props.type
 * @param props.isBig
 * @param props.onClick
 * @param props.shouldAutoPlay
 * @param props.height
 * @param props.minHeight
 * @returns {Element}
 * @constructor
 */
export default function ItemYoutubeVideo (props) {
  const {
    source,
    poster,
    type,
    isBig,
    onClick,
    shouldAutoPlay = false,
    minHeight
  } = props

  let {
    height
  } = props
  logUtil('ItemYoutubeVideo').debug('[start] prop=', props)
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const videoRef = React.useRef()
  const playerRef = React.useRef()
  const isMountedRef = React.useRef()
  const prevSource = usePreviousHookUtil(source)
  const hasChangedSource = prevSource && source !== prevSource

  React.useEffect(() => {
    isMountedRef.current = true
    initVideoJs()
    return () => {
      isMountedRef.current = false
      disposePlayer()
    }
  }, [])

  // const play = () => {
  //   playerRef.current.play()
  // }

  React.useEffect(
    () => {
      if (playerRef.current && hasChangedSource) {
        const newSrc = getSources()[0]
        logUtil('ItemYoutubeVideo#update').debug(`newSrc=${newSrc}`)
        playerRef.current.src(newSrc)
        // shouldAutoPlay && play()
      }
    },
    [
      hasChangedSource
    ]
  )

  const disposePlayer = () => {
    logUtil('ItemYoutubeVideo#disposePlayer').debug('[start]')
    if (!playerRef.current) {
      return
    }
    playerRef.current.dispose()
    playerRef.current = null
    videoRef.current = null
  }

  const getSources = () => {
    return [
      {
        type: 'video/youtube',
        src: source
      }
    ]
  }

  const getOption = () => {
    return {
      techOrder: [
        'Youtube',
        'html5'
      ],
      controls: true,
      autoplay: shouldAutoPlay,
      muted: !!shouldAutoPlay,
      preload: 'auto',
      poster: poster,
      sources: getSources()
    }
  }

  const initVideo = () => {
    if (!videoRef.current || !isMountedRef.current) {
      return
    }

    playerRef.current = videojs(videoRef.current, getOption())
    // if (shouldAutoPlay) {
    //   play()
    // }
  }

  const initVideoJs = async () => {
    await loadVideoJsYoutube()
    initVideo()
  }

  const loadVideoJsYoutube = async () => {
    if (!isMountedRef.current) {
      return
    }
    if (!videojs) {
      const [videojsModule] = await Promise.all([
        import(/* webpackChunkName: "video-js" */ 'video.js'),
        import(/* webpackChunkName: "video-js" */ 'video.js/dist/video-js.css')
      ])
      videojs = videojsModule.default
    }
    await import(/* webpackChunkName: "videojs-youtube" */ 'videojs-youtube')
  }

  logUtil('ItemYoutubeVideo')
    .debug(`type=${type}, source=${source}, poster=${poster}, isMountedRef.current=${isMountedRef.current}, hasChangedSource=${hasChangedSource}`)

  const handleClick = () => {
    onClick?.()
  }

  let width
  if (isSmallScreen) {
    width = '100%'
    height = height || 'calc(100vw / 1.777777778)'
  } else {
    width = (isBig ? '47.44em' : '35.55em')
    height = height || (isBig ? '26.66em' : '20em')
  }

  const className = classNames({
    'item-videoBody': true,
    'item-videoBody_youtube': true,
    'video-js': true,
    'vjs-fill': true,
    'vjs-default-skin': true,
    'vjs-big-play-centered': true
  })

  const style = {
    maxWidth: '100%',
    position: 'relative',
    width,
    height
  }

  if (minHeight) {
    style.minHeight = minHeight
  }
  return (
    <div
      style={style}
    >
      <video
        className={className}
        ref={videoRef}
        onClick={handleClick}
      />
    </div>
  )
}
